export var BuildingFlags;
(function (BuildingFlags) {
    BuildingFlags[BuildingFlags["LUXURIOUS"] = 1] = "LUXURIOUS";
})(BuildingFlags || (BuildingFlags = {}));
